import PlacesOfDepartureImages from "../../Utils/PlacesOfDepartureImages";

const initialState = {
    business: undefined,
    fetching: false,
    changing: false,
    fetched: false,
    error: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_BUSINESS_PENDING": {
            return {
                ...state,
                fetching: true
            };
        }
        case "FETCH_BUSINESS_FULFILLED": {
            if (PlacesOfDepartureImages.hasImages())
                PlacesOfDepartureImages.clearImages();

            if (action.payload && action.payload.placesOfDeparture) {
                for (let placeOfDeparture of action.payload.placesOfDeparture) {
                    PlacesOfDepartureImages.setImage(placeOfDeparture.name, placeOfDeparture.image);
                }
            }

            return {
                ...state,
                fetching: false,
                business: _.isEqual(state.business, action.payload) ? state.business : action.payload,
                fetched: true,
                error: null
            };
        }
        case "FETCH_BUSINESS_REJECTED": {
            return {
                ...state,
                fetching: false,
                error: action.payload
            };
        }
        case "EDIT_BUSINESS_PENDING": {
            return {
                ...state,
                business: action.meta,
                changing: true
            }
        }
        case "EDIT_BUSINESS_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            };
        }
        case "EDIT_BUSINESS_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }

        case "EDIT_DEFAULT_SLA_PENDING": {
            return {
                ...state,
                business: {
                    ...state.business, sla: action.meta.sla
                },
                changing: true
            }
        }
        case "EDIT_DEFAULT_SLA_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            };
        }
        case "EDIT_DEFAULT_SLA_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
    }

    return state;
}